export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4758.e338dd75.jpg";